<script lang="ts" setup>
import IMG_WITH_LABEL from '@assets/images/branding/vocal-identity-label-logo.svg'
import IMG_ONLY_LOGO from '@assets/images/branding/vocal-identity-logo.svg'
import { z } from 'zod'

type Numberish = string | number

const props = defineProps<{
  logoOnly?: boolean

  size?: Numberish
  width?: Numberish
  height?: Numberish

  /** Used to show custom logo instead of vocal */
  src?: unknown
}>()

function getSizeStyles() {
  const { size, height, width } = props

  return {
    width: `${size || width}px`,
    height: `${size || height}px`
  }
}

const customLogo = computed(() => z.string().url().safeParse(props.src))
const imageSrc = props.logoOnly ? IMG_ONLY_LOGO : IMG_WITH_LABEL
</script>

<template>
  <img
    v-if="customLogo.success"
    :src="customLogo.data"
    alt=""
    :width="size || width || 'auto'"
    :height="size || height || 'auto'"
    class="!bg-transparent"
    :style="getSizeStyles()"
  >

  <div
    v-else class="$bg-[$color-primary,@theme-colors-primary-500] bg-$bg" :style="{
      ...getSizeStyles(),
      maskImage: `url(${imageSrc})`,
      maskSize: '100% 100%',
      aspectRatio: logoOnly ? '1 / 1' : '71.5 / 24',
    }"
  />
</template>
